import { useDroppable } from "@dnd-kit/core";
import { memo, useMemo } from "react";

type Props = {
    id: string;
    content: any;
    isLoading: boolean;
    danger?: boolean;
};

const baseStyle = {
    position: 'absolute' as const,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'transparent',
    cursor: 'initial',
    zIndex: -1, // Moved the overlay to the bottom of the stack
};

// Memoize the content wrapper
const ContentWrapper = memo(({ children }: { children: React.ReactNode }) => {
    return <>{children}</>;
});

function ShiftDroppable({ id, content, isLoading, danger }: Readonly<Props>) {
    const { setNodeRef, isOver } = useDroppable({
        id: id,
    });

    // Memoize the dynamic styles
    const overlayStyle = useMemo(() => {
        if (!isOver) {
            return baseStyle;
        }

        return {
            ...baseStyle,
            zIndex: isOver ? 9999 : '-1',
            backgroundColor: isOver ? '#fbaa072b' : 'transparent',
            borderRadius: isOver ? '5px' : 'none',
            cursor: isOver ? 'grabbing' : 'initial',
        };
    }, [isOver]);

    return (
        <>
            <div
                className={`shift-droppable p-1 ${danger && !isLoading ? 'border border-danger rounded m-1' : ''} ${isLoading ? 'border border-primary rounded m-1' : ''}`}
                style={isLoading ? { filter: 'blur(1px)' } : {}}
            >
                <div
                    style={overlayStyle}
                    ref={setNodeRef}
                >
                </div>
                <ContentWrapper>
                    {content}
                </ContentWrapper>
            </div>
            {isLoading && (
                <i
                    className="pi pi-spin pi-spinner"
                    style={{
                        fontSize: '1rem',
                        color: 'white',
                        position: 'absolute',
                        //top: '0',
                        //right: '0',
                        top: 'calc(50% - 10px)',
                        left: 'calc(50% - 10px)',
                        zIndex: 1040, // TODO: may change based on the z-index of the each shift overlay/pop-over
                        backgroundColor: 'var(--primary-color)',
                        padding: '3px',
                        borderRadius: '50%',
                    }}
                />
            )}
        </>

    );
}

// Strict comparison function
const propsAreEqual = (prevProps: Props, nextProps: Props) => {
    return (
        prevProps.id === nextProps.id &&
        prevProps.content === nextProps.content // Ensure content does not trigger unnecessary updates
    );
};

export default memo(ShiftDroppable, propsAreEqual);